import DEFINE, { PATHS } from './../constants/Define';

export default[{
    title: "app",
    tagSub: "app",
    exact: false,
    path: PATHS.APP.path,
    icon: "mobile",
    show: true,
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.APP,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "appui",
            group: "appui",
            path: PATHS.APP.LIST.path,
            tagSub: "app",
            icon: "layout",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.APP,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "appUICreate",
                    group: "appui",
                    tagSub: "app",
                    path: PATHS.APP.CREATE.path,
                    exact: false,
                    icon: 'layout',
                    show: false,
                }, {
                    title: "appUIUpdate",
                    group: "appui",
                    tagSub: "app",
                    path: PATHS.APP.DETAIL.path,
                    exact: false,
                    icon: 'layout',
                    show: false,
                }
            ]
        },
        {
            title: "whitelistIp",
            group: "whitelistIp",
            path: PATHS.APP.WHITELIST.path,
            tagSub: "app",
            icon: "layout",
            show: true,
            routeName: 'whitelistip',
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.DELETE],
        }
    ]
}]
